import script from "./password-change-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./password-change-modal.vue?vue&type=script&setup=true&lang=ts"

import "./password-change-modal.vue?vue&type=style&index=0&id=144db7f3&lang=css"

const __exports__ = script;

export default __exports__